// extracted by mini-css-extract-plugin
var _1 = "_YpCkp74";
export { _1 as "contact" }
